//*** Import React Library 
import axios from "axios";
import { Button } from "bootstrap";
import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import { Route, Routes } from 'react-router-dom';
import { hasJWTToken } from "../Account/RouteGuard";
import AxiosInstance from '../Axios/AxiosInstance';
//*** Export current chart of grass cutting by months
export const ChartGrassCuttingByMonths = () => {
    const role_id = sessionStorage.getItem("role_id");
    const [chartData, setChartData] = useState({});
    const [data, setData] = useState([]);
    const areaCovered = [];
    const workingMonths = [];
    const robotName = [];
    // *** Return html code 
    const GetGrassCuttingByMonths = async () => {
        var plant_id = sessionStorage.getItem("user_plantid");
        //let response = await axios("/GrassCuttingByMonth?pid=" + plant_id + "&ot=GrassCutting");
        try {
            let response = await AxiosInstance.get("/GrassCuttingByMonth?pid=" + plant_id + "&ot=GrassCutting");
            if (response && typeof response.then === 'function') {
            response.then((res) => {
                if (res.data) setData(response.data);
            })
            response.catch(
                function (error) {
                    console.log('Error Message:' + error)
                }
                ) 
            }
            else {
                console.log("Response is not a promise");
            }
        }
        catch (error) {
            console.log('Error Message:' + error)
        }
        data.map((user) => {
            areaCovered.push(user.areaCovered);
            workingMonths.push(user.workingMonths);
        });
        //*** Set Chart Data
        setChartData({
            labels: workingMonths,
            datasets: [
                {
                    fill: true,
                    label: "Area Covarage in Meter (m) By Months",
                    data: areaCovered, //[0, 10, 5, 2, 20, 30, 45],
                    backgroundColor: ["rgba(255, 206, 86, 0.2)"], //"lemonyellow", //"#5ADEFF",
                    borderColor: ["rgba(255, 99, 132, 1)"],
                    borderWidth: 1
                }
            ]
        });
    };
     //*** Use React hooks - if occur any changes on page then useffect() function will run auto
    useEffect(() => {
        GetGrassCuttingByMonths();
    }, []);
    useEffect(() => {
        console.log(data)
    }, [data])
    GetGrassCuttingByMonths();
    // *** Return html code 
    return (
        <>
           {hasJWTToken() ? (
                                <div>
                                    <p></p>
                                    <h3 style={{ marginLeft: "2%" }}>Current Year Grass Cutting By Months</h3>
                                    <p></p>
                                    <p></p>
                                    {data.map((user) => (
                                        (user.id === 0 ? (
                                            <div key={user.id}>
                                                <Line data={chartData} />
                                            </div>
                                        ) : (<></>))
                                    ))}
                                </div>
                            ) :
                            (
                                window.location.href = "#/Login"
                            )
          }
        </>
    );
};